/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportFileInfo = {
    format: ReportFileInfo.format;
    /**
     * S3 key for the report file (used with secure download endpoint)
     */
    s3Key: string;
    /**
     * Size of the file in bytes
     */
    fileSizeBytes: number;
    /**
     * When the file was generated
     */
    generatedAt?: string;
};
export namespace ReportFileInfo {
    export enum format {
        JSON = 'JSON',
        CSV = 'CSV',
    }
}

